import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { QuestionStructure, AnswerStructure } from '../../tools/question';
import { ScenarioPart } from '../../models/scenario';
import { Question } from '../../models/question';
//import { NgSwitch, NgFor, NgForOf } from '@angular/common';
//import { Router, ActivatedRoute } from '@angular/router';
import { DataProvider } from '../../providers/data';
import { AppSettings } from '../../app/app.settings';
//import { AnalyticsService } from "../services/analytics.service";
//import { Tools } from '../../tools/tools';
import { WelcomePage } from '../welcome/welcome';
import { ProductsPage } from '../products/products';
import $ from 'jquery';

/**
 * Generated class for the QuestionnairePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-questionnaire',
  templateUrl: 'questionnaire.html',
})
export class QuestionnairePage {
  private questionnaire: ScenarioPart[] = [];

  //private scenarios: Scenario[];
  //private currentScenario: Scenario = new Scenario();

  public curCountry: string;

  public genderQuestion: QuestionStructure;
  public howOldQuestion: QuestionStructure;
  //private genderAnswer: string;
  //private howOldAnswer: string;

  private readonly STEP_PROGRESS: number = 17;
  private stepNumber: number = 1;
  private questions: Question[];

  get currentProgress(): number {
    return this.STEP_PROGRESS * this.stepNumber;
  }

  get currentTemplate(): string {
    if (!this.currentScenarioPart) return 'sex&age';
    else if (this.currentScenarioPart.question === 'zone') return 'area';
    return 'standart';
  }

  get currentOptions(): string[] {
    if (this.currentScenarioPart && typeof this.currentScenarioPart.answers === 'object') {
      let answers = Object.keys(this.currentScenarioPart.answers);
      if (this.questions) {
        let sortedAnswers = this.questions.filter(q => q.question_text === this.currentScenarioPart.question)[0].answers;
        answers = answers.sort((a1, a2) => {
          let sort1 = sortedAnswers.filter(sa => sa.answer_text == a1)[0].sort;
          let sort2 = sortedAnswers.filter(sa => sa.answer_text == a2)[0].sort;
          if (sort1 > sort2) return 1;
          if (sort1 < sort2) return -1;
          return 0;
        });

        //temporary decision of same answers hover
        if (this.currentScenarioPart.question == 'sun') {
          for (let i = 0; i < answers.length; i++) {
            answers[i] += ' ';
          }
        }

      }
      return answers;
    }
    return [];
  }

  /*get currentChecks(): boolean[] {
    //return this.currentQuestion ? this.currentQuestion.template : null;
    let che = [];
    if (this.currentScenarioPart && typeof this.currentScenarioPart.answers === 'object')
      for (let ans of Object.keys(this.currentScenarioPart.answers))
        che.push(false);
    return che;
  }*/

  // get currentStep(): number {
  //   return this.questionnaire.length || 1;
  // }

  //private gender: string;
  //private zone: string;
  public currentScenarioPart: ScenarioPart = null;

  //private wasRestart: boolean;

  public get getGender() {
    return localStorage.getItem('es-gender');
  }

  public get getHowOld() {
    return localStorage.getItem('es-howOld');
  }
  //public temp: any[] = [];

  public userHasScrolled: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams, /*private router: Router, private activatedRoute: ActivatedRoute,*/
              private dataService: DataProvider/*, public analyticsService: AnalyticsService*/) {
    this.genderQuestion = new QuestionStructure('gender', ['female', 'male']);
    this.howOldQuestion = new QuestionStructure('howOld', ['18-25', '26-35', '36-50', '50+']);
    //this.wasRestart = <boolean>this.activatedRoute.snapshot.queryParams['restart'];
    // for (let i = 0; i < 20; i++) {
    //   this.temp.push({ answerBorderWidth: 1, answerTextColor: "#808080", answerBackgroundColor: '#FFFFFF' });
    // }

    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ionViewDidLoad() {
    this.dataService.getQuestions().subscribe(questionsData => {
      this.questions = questionsData;
    });
    this.dataService.loadScenarios().then(
      response => {
        // if (this.wasRestart) {
        //     this.initQuestionnaire();
        // }
        // else {
        // this.analyticsService.emitQuestionPageView('demo');
        //}
      },
      error => console.log(error)
    );
    //console.log(this.dataService.scenariosObject);
  }

  //public answerBorderWidth: number = 1;
  //public answerTextColor = "#808080";
  //public answerBackgroundColor = '#FFFFFF';

  //public keepSelected(e: any) {
    //this.temp[i].answerBorderWidth = 0;
    //this.temp[i].answerTextColor = "#FFFFFF";
    //this.temp[i].answerBackgroundColor = '#A40532';
    //$(<Element>e.target).css("border", "none");
    //$(<Element>e.target).css("background", "#A40532");
    //$(<Element>e.target).css("color", "#FFFFFF");
    // this.router.navigate(['/questionnaire']);
  //}

  // private clearTemp() {
  //   for (let i = 0; i < 20; i++) {
  //     this.temp[i].answerBorderWidth = 1;
  //     this.temp[i].answerTextColor = "#808080";
  //     this.temp[i].answerBackgroundColor = '#FFFFFF';
  //   }
  // }

  public highlightAnswer(e: any) {
    this.userHasScrolled = false;
    $(<Element>e.target).css("border", "1px solid #FFFFFF");
    $(<Element>e.target).css("background", "#A40532");
    $(<Element>e.target).css("color", "#FFFFFF");
  }

  public blockTransferIfScroll(e: any) {
    this.userHasScrolled = true;
  }

  // public keepSelected(e: any) {
  //     $(<Element>e.target).css("border", "1px solid #FFFFFF");
  //     $(<Element>e.target).css("background", "#A40532");
  //     $(<Element>e.target).css("color", "#FFFFFF");
  // }

  public cleanHighlightAnswer(e: any) {
    $(<Element>e.target).css("border", "1px solid #989999");
    $(<Element>e.target).css("background", "#FFFFFF");
    $(<Element>e.target).css("color", "#808080");
  }

  public touchEnd(e: any) {
    this.cleanHighlightAnswer(e);
    if (this.userHasScrolled) return;
  }

  public answerClick(e: any, answer: string) {
    this.cleanHighlightAnswer(e);
    if (this.userHasScrolled) return;

    if (this.currentScenarioPart.question === 'zone') {
      localStorage.setItem('es-zone', answer);
    }

    //this.analyticsService.emitEvent('question', `question-${this.currentScenarioPart.question}_choose-${answer}`);

    let nextScenarioPart: ScenarioPart = this.currentScenarioPart.answers[answer];

    //some patches
    if (AppSettings.CONFIG.country_code === 'kw' && this.getGender === 'male' && nextScenarioPart) {
      if (nextScenarioPart.question === 'age') {
        nextScenarioPart = nextScenarioPart.answers['No'];
      }
      if (nextScenarioPart.question === 'sunConcern') {
        delete nextScenarioPart.answers['Even skin tone'];
      }
    }

    this.goToNextQuestion(nextScenarioPart);
  }

  public answerSexClick(answer: AnswerStructure) {
    for (let answerOption of this.genderQuestion.options) {
      answerOption.checked = false;
    }
    answer.checked = true;

    localStorage.setItem('es-gender', answer.answerText);

    if (this.howOldQuestion && this.howOldQuestion.options.every(ao => ao.checked !== true))
      return;

    //let genderHowOld = answer.answerText + this.howOldQuestion.options.filter(o => o.checked)[0].answerText;
    //this.analyticsService.emitEvent('question', `question-demo_choose-${genderHowOld}`);

    this.goToNextQuestion();
  }

  public answerAgeClick(answer: AnswerStructure) {
    for (let answerOption of this.howOldQuestion.options) {
      answerOption.checked = false;
    }
    answer.checked = true;

    localStorage.setItem('es-howOld', answer.answerText);

    if (this.genderQuestion.options.every(ao => ao.checked !== true))
      return;

    //let genderHowOld = this.genderQuestion.options.filter(o => o.checked)[0].answerText + answer.answerText;
    //this.analyticsService.emitEvent('question', `question-demo_choose-${genderHowOld}`);

    this.goToNextQuestion();
  }

  private initQuestionnaire() {
    this.currentScenarioPart = this.dataService.scenariosObject;
    //this.analyticsService.emitQuestionPageView(this.currentScenarioPart.question);
  }

  private goToNextQuestion(nextScenarioPart: ScenarioPart = null) {
    this.stepNumber++;
    //this.clearTemp();

    if (!this.currentScenarioPart) {
      this.initQuestionnaire();
      return;
    }

    this.questionnaire.push(this.currentScenarioPart);

    if (nextScenarioPart.question === AppSettings.RESULT_FIELD) {
      //this.analyticsService.emitEvent('result', `result_questions_${this.questionnaire.length + 2}`);

      this.questionnaire.push(nextScenarioPart);
      this.defineProducts(nextScenarioPart.answers);
      console.log(this.questionnaire);
    }
    else {
      this.currentScenarioPart = nextScenarioPart;
      //this.analyticsService.emitQuestionPageView(this.currentScenarioPart.question);
    }
  }

  private goToPrevQuestion() {
    this.stepNumber--;
    //this.clearTemp();
    if (this.questionnaire.length == 0) {
      this.currentScenarioPart = null;
      //this.analyticsService.emitQuestionPageView('demo');
      return;
    }

    let prevScenarioPart = this.questionnaire.pop();
    this.currentScenarioPart = prevScenarioPart;
    //this.analyticsService.emitQuestionPageView(this.currentScenarioPart.question);
  }

  public backButtonClick() {
    if (!this.currentScenarioPart) {
      //this.router.navigate(['/welcome']);
      this.navCtrl.push(WelcomePage);
    }
    else {
      this.goToPrevQuestion();
    }
  }

  private defineProducts(productIdLists: any) {
    console.log(productIdLists);
    let scenarioString: string = "";
    let prevScenarioPart: ScenarioPart;
    for (let scenarioPart of this.questionnaire) {
      if (scenarioPart == this.questionnaire[0]) {
        prevScenarioPart = scenarioPart;
        continue;
      }
      let answers = Object.getOwnPropertyNames(prevScenarioPart.answers);
      for (let answer of answers) {
        if (Object.is(prevScenarioPart.answers[answer], scenarioPart))
          scenarioString += answer + '/';
      }
      prevScenarioPart = scenarioPart;
    }

    console.log(scenarioString);
    this.dataService.getProductExceptions(this.getGender, this.getHowOld, scenarioString)
      .subscribe(exceptingIds => {
        let resultObject = {};
        for (let prodType of AppSettings.PROD_TYPES) {
          let productIdList = productIdLists[prodType]
          if (productIdList) {
            console.log(exceptingIds);
            for (let id of exceptingIds) {
              let index = productIdList.indexOf(id);
              if (index !== -1)
                productIdList.splice(index, 1);
            }
            resultObject[prodType] = productIdList.join(',');
          }
        }
        this.navCtrl.push(ProductsPage, resultObject);
        //this.router.navigate(['/products'], { queryParams: resultObject });
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/questionnaire/questionnaire.ts